import type { ApiErrorResponse } from '@/types/api';
import { Typography } from '@fleet/webshop-ui';
import type { ReactNode } from 'react';
import { toast } from 'react-toastify';

/**
 * Shows an error toast with a generic message and optional API error reason
 *
 * @param genericMessage - The main error message to display (can be TransText, string, or any ReactNode)
 * @param error - The API error response to extract the error reason from
 *
 * @example
 * ```tsx
 * showErrorToast(
 *   <TransText i18nKey="failedToCreateBooking" />,
 *   error
 * );
 * ```
 */
export const showErrorToast = (
  genericMessage: ReactNode,
  error: ApiErrorResponse
) => {
  const reason = error.response?.data.errors?.[0]?.message;

  toast.error(
    <div className="flex gap-1">
      {genericMessage}
      {reason && <Typography>{reason}</Typography>}
    </div>
  );
};
